var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"value":_vm.isOpen,"fullscreen":"","no-click-animation":"","persistent":""},on:{"keydown":_vm.handleKeyDown}},[_c('v-card',{staticClass:"image-editor"},[_c('div',{staticClass:"image-editor-container",attrs:{"id":_vm.containerId}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }